import type { BBox, NewRestroom, Restroom, RestroomFilters } from "../types";

async function handle<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new Error(body?.error ?? `Požadavek selhal (${res.status})`);
  }
  return res.json() as Promise<T>;
}

export async function fetchRestrooms(
  bbox: BBox,
  limit: number,
  filters?: RestroomFilters,
): Promise<Restroom[]> {
  const params = new URLSearchParams({ bbox: bbox.join(","), limit: String(limit) });
  // Jen zapnuté filtry – vypnutý filtr se neposílá, ať se URL nemění zbytečně.
  if (filters?.wheelchair) params.set("wheelchair", "1");
  if (filters?.free) params.set("free", "1");
  if (filters?.changingTable) params.set("changingTable", "1");
  const res = await fetch(`/api/restrooms?${params}`);
  return handle<Restroom[]>(res);
}

export async function fetchRestroom(id: number): Promise<Restroom> {
  const res = await fetch(`/api/restrooms/${id}`);
  return handle<Restroom>(res);
}

export async function createRestroom(
  data: NewRestroom,
  turnstileToken: string,
): Promise<Restroom> {
  const res = await fetch("/api/restrooms", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ ...data, turnstileToken }),
  });
  return handle<Restroom>(res);
}
